import { toast } from 'react-toastify';

// One error, one toast (Nic 2026-10-23: "It fires twice every time"). A 403
// is toasted by the app's axios interceptor (MainRouter) AND by the button
// that made the call, with the same words. Same words = same toastId, so
// react-toastify shows it once while the first is still up. Only error
// toasts, only string messages, only when the caller didn't pick an id.
export const errorToastId = (message) => `error:${message}`;

let installed = false;
export const installToastDedupe = () => {
  if (installed) return;
  installed = true;
  const original = toast.error;
  toast.error = (content, options = {}) =>
    original(
      content,
      typeof content === 'string' && !options?.toastId ? { ...options, toastId: errorToastId(content) } : options,
    );
};
